// Dependencies
import {
	useMemo
} from 'react'

// Types

// Hooks
import { useDebug, useWindowResize } from '../hooks'

// Components
//import DesktopMenuVertical from '../components/DesktopMenuVertical'
import MobileMenu from '../components/MobileMenu'

// Types.MegamenuOptions
const Megamenu = ({loading, errors, ...props}: any) => {
  useDebug('Containers/Megamenu')
  //console.log(props);
  
  // Hooks
  const [underBreakpoint] = useWindowResize({cssAtts: true, breakpoint: props.config.general.mobileBreakpoint}) 

  // const Menu = useMemo(
  //   // () => ! underBreakpoint ? DesktopMenu : MobileMenu,
  //   [underBreakpoint],
  // )

  // const [isDarkMode, setIsDarkMode] = React.useState<boolean|null>(true);

  // Merge the defaults with custom props
  // const options: Types.MegamenuOptions = React.useMemo(() => {
  //   const {theme, ...appData} = props;
  //   return {theme: ('dark' in theme || 'light' in theme) ? isDarkMode ? theme.dark : theme.light : theme, ...appData}
  // }, [props, isDarkMode]);
  // const options: Types.MegamenuOptions = React.useMemo(() => {
  //   const {theme, ...appData} = props;
  //   return {theme: ('dark' in theme || 'light' in theme) ? isDarkMode ? theme.dark : theme.light : theme, ...appData}
  // }, [props, isDarkMode]);
  
  // React.useEffect(() => {

  //   // TODO: Have a option to configure this
  //   autoSetIsDarkMode();

  //   window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', autoSetIsDarkMode);
  //   return window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', autoSetIsDarkMode);

  // }, []);

  // const autoSetIsDarkMode = () => {
    
  //   const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  //   // TODO: Be able to configure this hour range
  //   const isNightTime = new Date().getHours() >= 20 || new Date().getHours() < 6;
    
  //   setIsDarkMode( prefersDarkMode || isNightTime );

  // }

  return underBreakpoint ? <MobileMenu {...{...props}} /> : null;
}

export default Megamenu
 